const EndCapSection = () => {
  return (
    <section className="mb-20" data-cy="end-cap-section">
      <div className="mb-10 text-center text-6xl font-bold">
        Start your health journey today
      </div>
      <div className="flex flex-row items-center justify-center gap-10 px-10">
        <div className="h-[600px] w-full rounded-2xl bg-sandstone-500" />
        <div className="h-[600px] w-full rounded-2xl bg-sandstone-500" />
      </div>
    </section>
  );
};

export default EndCapSection;
